// eslint-disable-next-line import/extensions
import YkcNotification from './src/main.js';

export default YkcNotification;
